(() => {
  'use strict';
  if (window.ATBrandedLoading) return;
  const source = document.querySelector('script[data-at-loading-logo]');
  if (!source) return;
  const logo = source.dataset.atLoadingLogo;
  const pending = new Map();
  const navigation = new Set();
  let nextId = 0, showTimer = 0, overlay;
  const language = () => window.ATLocale?.language || document.documentElement.dataset.atLanguage || source.dataset.atLoadingLanguage || document.documentElement.lang;
  const label = () => {const en=/^en\b/i.test(language());const value=en ? source.dataset.atLoadingEn : source.dataset.atLoadingAr;return value && !/translation missing/i.test(value) ? value : (en ? 'Loading' : 'جاري التحميل');};
  function indicator(size = '') {
    const node = document.createElement('div');
    node.className = 'at-brand-loader' + (size ? ' at-brand-loader--' + size : '');
    node.dataset.atBrandIndicator = '';
    node.setAttribute('role', 'status');
    node.setAttribute('aria-live', 'polite');
    node.innerHTML = '<span class="at-brand-loader__halo" aria-hidden="true"></span><span class="at-brand-loader__wave" aria-hidden="true"></span><span class="at-brand-loader__wave at-brand-loader__wave--second" aria-hidden="true"></span><span class="at-brand-loader__logo"><img alt="" width="88" height="88"><span class="at-brand-loader__light" aria-hidden="true"></span></span><span class="at-brand-loader__label"><span data-at-brand-label></span><span class="at-brand-loader__dots" aria-hidden="true">…</span></span>';
    node.querySelector('img').src = logo;
    node.querySelector('[data-at-brand-label]').textContent = label();
    return node;
  }
  function mount() {
    if (overlay || !document.body) return;
    overlay = document.getElementById('at-global-loading');
    if (overlay) {overlay.querySelector('[data-at-brand-label]').textContent=label();if(document.documentElement.classList.contains('at-loading-boot')){overlay.classList.add('at-is-visible');overlay.setAttribute('aria-hidden','false');}return;}
    overlay = document.createElement('div');
    overlay.id = 'at-global-loading';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.append(indicator());
    document.body.append(overlay);
  }
  function sync() {
    mount();
    if (!overlay) return;
    if (pending.size) {
      if (showTimer || overlay.classList.contains('at-is-visible')) return;
      showTimer = window.setTimeout(() => {
        showTimer = 0;
        if (!pending.size) return;
        overlay.querySelector('[data-at-brand-label]').textContent = label();
        overlay.classList.add('at-is-visible');
        overlay.setAttribute('aria-hidden', 'false');
      }, 120);
    } else {
      window.clearTimeout(showTimer);
      showTimer = 0;
      overlay.classList.remove('at-is-visible');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }
  function begin(timeout = 0) {
    const id = ++nextId;
    const timer = timeout > 0 ? window.setTimeout(() => finish(id), timeout) : 0;
    pending.set(id, timer);
    sync();
    return id;
  }
  function finish(id) {
    if (!pending.has(id)) return;
    window.clearTimeout(pending.get(id));
    pending.delete(id);
    sync();
  }
  function businessRequest(input, init) {
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      const headers = new Headers(init?.headers || input?.headers || undefined);
      if (/text\/event-stream/i.test(headers.get('accept') || '') || headers.get('x-at-background-request') === '1') return false;
      if (/\/rest\/v1\/rpc\/(?:at_access_me|admin_get_my_profile_secure|at_mail_inbox_secure|at_mail_admin_authorize)$/.test(url.pathname)) return false;
      if (/\/auth\/v1\/token$/.test(url.pathname) && url.searchParams.get('grant_type') === 'refresh_token') return false;
      if (/\/storage\/v1\/(?:object|render)\//.test(url.pathname)) return false;
      const method = (init?.method || input?.method || 'GET').toUpperCase();
      if (document.body?.classList.contains('at-admin-redesign') && (url.pathname === '/functions/v1/at-v10-noon-prices' || (method === 'GET' && ['/rest/v1/at_inventory_products','/rest/v1/at_access_v_at_inventory_products'].includes(url.pathname)))) return false;
      if (/\.(?:js|css|png|jpg|jpeg|gif|svg|woff2?|mp4)(?:$|\?)/i.test(url.pathname)) return false;
      if(document.body?.classList.contains('at-admin-redesign')&&['/rest/v1/rpc/at_v25_home','/functions/v1/at-v25-home','/rest/v1/rpc/at_wa_inbox_v28','/rest/v1/rpc/at_wa_auto_v28','/functions/v1/at-whatsapp-inbox-v28'].includes(url.pathname))return false;
      if(document.body?.classList.contains('at-admin-redesign')&&/\/rest\/v1\/rpc\//.test(url.pathname)){
        const rpc=url.pathname.split('/').pop();
        if(['at_v29_reporting','at_v29_filing_documents','at_v13_reporting'].includes(rpc)){
          try{const body=typeof init?.body==='string'?JSON.parse(init.body):null;if(['boot','dataset','ledger','vat','vat_rows','filings','list','read','report','document_read','snapshot_read'].includes(body?.p_action))return false;}catch(_){}
        }
        const mutation=/(?:^|_)(?:save|apply|approve|decide|submit|create|update|delete|cancel|record|import|sync|mark|reverse|resume|upload|post|clear|reset|zero|edit|receive|request|add)(?:_|$)/.test(rpc);
        if(!mutation&&/(?:^|_)(?:get|find|list|read|detail|dashboard|metrics|snapshot|summary|state|timeline|events)(?:_|$)/.test(rpc))return false;
        if(['at_transfer_v25_secure','at_damage_v27_secure','at_damage_v26_secure','at_admin_approval_conversation_v24_secure'].includes(rpc)){
          try{const data=typeof init?.body==='string'?JSON.parse(init.body):null;const action=data?.p_action;if(['list','detail','product','state','search','dashboard','get'].includes(action))return false;}catch(_){}
        }
      }
      return url.origin === location.origin || (/\.supabase\.(?:co|in)$/.test(url.hostname) && /^\/(?:rest|auth|functions|storage)\//.test(url.pathname));
    } catch { return false; }
  }
  const originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function(input, init) {
      if (!businessRequest(input, init)) return originalFetch.apply(this, arguments);
      const id = begin();
      let promise;
      try { promise = originalFetch.apply(this, arguments); }
      catch (error) { finish(id); throw error; }
      return promise.then(response => {
        let consumed=false;
        const fallback=window.setTimeout(()=>finish(id),0);
        for(const method of ['json','text','blob','arrayBuffer','formData']){
          const read=response[method];if(typeof read!=='function')continue;
          response[method]=function(){
            if(consumed)return read.apply(this,arguments);
            consumed=true;window.clearTimeout(fallback);
            try{return read.apply(this,arguments).then(value=>{finish(id);return value;},error=>{finish(id);throw error;});}
            catch(error){finish(id);throw error;}
          };
        }
        return response;
      },error=>{finish(id);throw error;});
    };
  }
  const xhrUrls = new WeakMap();
  const open = XMLHttpRequest.prototype.open;
  const send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    const result = open.apply(this, arguments);
    xhrUrls.set(this, String(url));
    return result;
  };
  XMLHttpRequest.prototype.send = function() {
    if (!businessRequest(xhrUrls.get(this) || '', {body:arguments[0]})) return send.apply(this, arguments);
    const id = begin();
    const end = () => finish(id);
    this.addEventListener('loadend', end, {once:true});
    try { return send.apply(this, arguments); }
    catch(error) { this.removeEventListener('loadend', end); finish(id); throw error; }
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.hasAttribute('data-at-no-loader')) return;
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || (url.pathname === location.pathname && url.search === location.search)) return;
    queueMicrotask(() => { if (!event.defaultPrevented) navigation.add(begin(15000)); });
  });
  document.addEventListener('submit', event => {
    queueMicrotask(() => {
      const form = event.target;
      if (event.defaultPrevented || form.method === 'dialog' || (form.target && form.target !== '_self')) return;
      try { if (new URL(form.action, location.href).origin === location.origin) navigation.add(begin(15000)); } catch {}
    });
  });
  function start() {
    mount();
    document.documentElement.classList.remove('at-loading-boot');
    sync();
  }
  window.addEventListener('pagehide', () => {for (const id of navigation) finish(id);navigation.clear();});
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    for (const id of Array.from(pending.keys())) finish(id);
  });
  window.ATBrandedLoading = Object.freeze({begin,finish,run: async task => {const id=begin();try{return await task();}finally{finish(id);}}});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();






